import React from 'react';
import { IconClose } from '@op/opds.opux-icons/navigation';
import { buildVersionedClass } from '@op/opds.opux-utilities';
import Button from '../button/button';
import { useLocale } from '../common/locale';
import messages from './_messages';
export const CloseButton = _ref => {
  let {
    setControlledVisible
  } = _ref;
  const lc = useLocale();
  const handleCloseButtonClick = event => {
    event.preventDefault();
    setControlledVisible(false);
  };
  return /*#__PURE__*/React.createElement(Button, {
    className: buildVersionedClass('ds-popup-hint__close'),
    compact: true,
    ghost: true,
    icon: IconClose,
    iconLabel: messages[lc].close,
    iconProps: {
      color: 'default'
    },
    onBlur: event => handleCloseButtonClick(event),
    onClick: event => handleCloseButtonClick(event),
    onKeyDown: event => {
      if (event.key === ' ' || event.key === 'Enter' || event.key === 'Escape') {
        handleCloseButtonClick(event);
      }
    },
    type: "button"
  });
};